import { UseFormReturn } from "react-hook-form";
import { BillingAddressForm } from "../../Training.types";

export const updateBillingAddressFormValues = (
  billingAddressFormMethods: UseFormReturn<BillingAddressForm>,
  updatedValues: BillingAddressForm
) => {
  billingAddressFormMethods.setValue(
    "streetAddressLine1",
    updatedValues.streetAddressLine1
  );
  billingAddressFormMethods.setValue(
    "streetAddressLine2",
    updatedValues.streetAddressLine2 || ""
  );
  billingAddressFormMethods.setValue("country", updatedValues.country);
  billingAddressFormMethods.setValue(
    "zipcodeOrPostalCode",
    updatedValues.zipcodeOrPostalCode
  );
  billingAddressFormMethods.setValue("city", updatedValues.city);
  billingAddressFormMethods.setValue(
    "stateOrProvince",
    updatedValues.stateOrProvince
  );
};
